import startCase from 'lodash/startCase';

export type FieldValueLabelMaps = Record<string, Record<string, string>>;

/**
 * Resolve a raw API value to its display label using config-driven maps.
 *
 * @param rawValue          Raw value from the API (e.g. 'coupon_digital')
 * @param labelMaps         The fieldValueLabelMaps dictionary from config
 * @param resolveLabelFrom  Key in labelMaps to look up (e.g. 'mechanic'); if
 *                          absent or not found, falls back to startCase
 */
export const resolveFieldLabel = (
    rawValue: string | null | undefined,
    labelMaps: FieldValueLabelMaps,
    resolveLabelFrom?: string,
): string => {
    if (!rawValue) return '';
    if (resolveLabelFrom) {
        const mapped = labelMaps[resolveLabelFrom]?.[rawValue];
        if (mapped) return mapped;
    }
    return startCase(rawValue);
};
